module.exports = __webpack_public_path__ + "img/600.85c83585.png";